import {useCallback, useMemo} from 'react'
import {requestData} from 'services'
import {useSelector} from 'lib/redux'
import {useFirebaseUser} from 'utils/firebase'

export function usePolicyUpdateHooks() {
  const {id} = useSelector('user') || {}
  const userData = useFirebaseUser({id: id || ''}).data

  const isPromptPrivacy = useMemo(
    () => (id && userData ? !!userData.is_prompt_policy : undefined),
    [id, userData],
  )

  const handleAcceptPolicyUpdate = useCallback(async () => {
    const response = await requestData('accept_privacy_policy')
    if (typeof response !== 'string') {
      return response.status
    }
    return undefined
  }, [])

  return useMemo(() => ({handleAcceptPolicyUpdate, isPromptPrivacy}), [
    handleAcceptPolicyUpdate,
    isPromptPrivacy,
  ])
}
